import {
  Component,
  ElementRef,
  ViewChild
} from '@angular/core';

interface ChatMessage {
  role: 'user' | 'assistant';
  content: string;
}

@Component({
  selector: 'app-assetto-gpt',
  templateUrl: './assetto-gpt.component.html',
  styleUrls: ['./assetto-gpt.component.css']
})
export class AssettoGptComponent {

  @ViewChild('chatContainer')
  chatContainer!: ElementRef;

  userInput = '';

  currentMessages: ChatMessage[] = [];

  suggestions: string[] = [
    'Show all assets',
    'Show offline devices',
    'Check network status',
    'Generate asset report'
  ];


  sendMessage(): void {

    const message = this.userInput.trim();

    if (!message) {
      return;
    }

    this.currentMessages.push({
      role: 'user',
      content: message
    });

    this.userInput = '';

    // Replace this with your API call
    setTimeout(() => {

      this.currentMessages.push({
        role: 'assistant',
        content: `I can help you with "${message}".`
      });

      this.scrollToBottom();

    }, 500);

    this.scrollToBottom();
  }


  useSuggestion(suggestion: string): void {

    this.userInput = suggestion;

    this.sendMessage();
  }


  handleKeyDown(event: KeyboardEvent): void {

    if (
      event.key === 'Enter' &&
      !event.shiftKey
    ) {

      event.preventDefault();

      this.sendMessage();
    }
  }


  clearChat(): void {

    this.currentMessages = [];

    this.userInput = '';
  }


  newChat(): void {

    this.clearChat();
  }


  onFileSelected(event: any): void {
    const files = event.target.files;
    if (files && files.length > 0) {
      const fileNames = Array.from(files).map((f: any) => f.name).join(', ');
      
      this.currentMessages.push({
        role: 'user',
        content: `[Attached file(s): ${fileNames}]`
      });

      setTimeout(() => {
        this.currentMessages.push({
          role: 'assistant',
          content: `I have received your file(s). However, file processing is not fully implemented in this demo.`
        });
        this.scrollToBottom();
      }, 500);

      this.scrollToBottom();

      // Reset the file input so the same file can be selected again
      event.target.value = '';
    }
  }


  private scrollToBottom(): void {

    setTimeout(() => {

      if (this.chatContainer) {

        const element = this.chatContainer.nativeElement;

        element.scrollTop = element.scrollHeight;
      }

    }, 50);
  }

}
